

export function domacnostiButton_mouseIn(event) {
	$w("#boxMenuDomacnosti").show();
}


export function domacnostiButton_mouseOut(event) {
	$w("#boxMenuDomacnosti").hide();
}

export function boxMenuDomacnosti_mouseIn(event) {
	$w("#boxMenuDomacnosti").show();
}

export function boxMenuDomacnosti_mouseOut(event) {
	$w("#boxMenuDomacnosti").hide();
}


export function firmyButton_mouseIn(event) {
	$w("#boxMenuFirmy").show();
}


export function firmyButton_mouseOut(event) {
	$w("#boxMenuFirmy").hide();
}


export function infoButton_mouseIn(event) {
	$w("#boxMenuInfo").show();
}

export function infoButton_mouseOut(event) {
	$w("#boxMenuInfo").hide();
}

export function boxMenuInfo_mouseIn(event) {
	$w("#boxMenuInfo").show();
}

export function boxMenuInfo_mouseOut(event) {
	$w("#boxMenuInfo").hide();
}

export function boxMenuDomacnosti_mouseIn_1(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}

export function boxMenuDomacnosti_mouseIn_2(event) {
	$w("#boxMenuDomacnosti").show();
}

export function boxMenuDomacnosti_mouseOut_1(event) {
	$w("#boxMenuDomacnosti").hide();
}

export function boxMenuFirmy_mouseIn(event) {
	$w("#boxMenuFirmy").show();
}

export function boxMenuFirmy_mouseOut(event) {
	$w("#boxMenuFirmy").hide();
}